import React, { useEffect, useRef } from 'react';

const PageContent = ({ children }) => {
    const contentRef = useRef(null);
    const isTouching = useRef(false);
    const interactionTimeout = useRef(null);
  
    useEffect(() => {
      const handleTouchStart = () => {
        isTouching.current = true; // Флаг, что началось касание
      };
  
      const handleTouchEnd = () => {
        isTouching.current = false; // Касание завершилось
  
        // Проверяем позицию скролла после завершения касания
        if (interactionTimeout.current) {
          clearTimeout(interactionTimeout.current);
        }
  
        interactionTimeout.current = setTimeout(() => {
          const { scrollTop } = contentRef.current;
          if (scrollTop > 0) {
            contentRef.current.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        }, 200); // Задержка перед возвратом
      };
  
      const handleScroll = () => {
        // Не обрабатываем скролл, пока активен touch
        if (isTouching.current) return;
  
        if (interactionTimeout.current) {
          clearTimeout(interactionTimeout.current);
        }
  
        interactionTimeout.current = setTimeout(() => {
          const { scrollTop } = contentRef.current;
          if (scrollTop > 0) {
            contentRef.current.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        }, 200); // Задержка
      };
  
      const contentElement = contentRef.current;
  
      contentElement.addEventListener('touchstart', handleTouchStart);
      contentElement.addEventListener('touchend', handleTouchEnd);
      contentElement.addEventListener('scroll', handleScroll);
  
      return () => {
        contentElement.removeEventListener('touchstart', handleTouchStart);
        contentElement.removeEventListener('touchend', handleTouchEnd);
        contentElement.removeEventListener('scroll', handleScroll);
  
        if (interactionTimeout.current) {
          clearTimeout(interactionTimeout.current);
        }
      };
    }, []);

    return (
        <div
            ref={contentRef}
            className="page-top"
        >
            {children}
        </div>
    );
};

export default PageContent;
